import { TabContent, Tabs, TabsList } from "@sembark-travel/ui-base"
import { NavLink } from "@sembark-travel/ui-router"
import { Outlet, useSearchParams } from "react-router"

/**
 * Monthly Accounts by tenant (the default) or by user. Switching keeps the
 * month only; each tab has its own filters.
 */
export default function MonthlyAccountsLayoutPage() {
	const [searchParams] = useSearchParams()
	const month = searchParams.get("month")
	const query = month ? { month } : undefined
	return (
		<Tabs>
			<TabsList>
				<NavLink to="." end query={query}>
					Tenants
				</NavLink>
				<NavLink to="users" query={query}>
					Users
				</NavLink>
			</TabsList>
			<TabContent>
				<Outlet />
			</TabContent>
		</Tabs>
	)
}
